import { isServerSide } from "@jti/fe-common";
import { PAGE_HEADER_ID } from "@jti/ui";

export const scrollToElementWithHeaderCompensation = (element: HTMLElement | null) => {
  if (isServerSide() || !element) {
    return;
  }

  const targetPositionOffset = element.getBoundingClientRect().top;
  const currentPositionOffset = targetPositionOffset + window.scrollY;
  const headerHeight = document.getElementById(PAGE_HEADER_ID)?.offsetHeight ?? 0;

  window.scrollTo({
    top: currentPositionOffset - headerHeight,
    behavior: "smooth",
  });
};
